const navAnchor = {
	
	ui: {},

	init: function() {
		document.querySelectorAll('.js-navAnchor').forEach(anchor => {
			anchor.addEventListener('click', (e) => {
				e.preventDefault();
				const targetId = anchor.getAttribute('href').substring(1);
				document.getElementById(targetId)?.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				});
			});
		});
	},
};

module.exports = navAnchor;